export default __webpack_public_path__ + "static/media/4-author.a41544e5.png";